import { Text } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { Actor } from "@zapier/canvas-state";
import styles from "./ActorLabel.module.css";

type Props = {
  actor: Actor;
};

export function ActorLabel({ actor }: Props) {
  return (
    <div className={styles.root}>
      <Icon name="personCircleFill" size={16} color="TextInverted" />
      <div className={styles.truncateText}>
        <Text type="MinimalPrint2" color="TextInverted">
          {actor.label}
        </Text>
      </div>
    </div>
  );
}
